module.exports = __webpack_public_path__ + "static/img/7.054b12a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/7.png
// module id = xz55
// module chunks = 0